import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import {
  Sparkles,
  Target,
  Copy,
  Layers,
  Zap,
  ShieldCheck,
} from "lucide-react";

const benefits = [
  {
    icon: Sparkles,
    title: "AI-Crafted Messaging",
    description:
      "Purpose-built for Google Ads, not generic marketing fluff. Every word is optimised for ad performance.",
  },
  {
    icon: Target,
    title: "Competitor Differentiation",
    description:
      "Stand out from every other ad in the auction. Your value proposition highlights what truly makes you unique.",
  },
  {
    icon: Copy,
    title: "Ad-Ready Copy",
    description:
      "Get headline, description, and landing page variations — all within Google Ads character limits, ready to paste.",
  },
  {
    icon: Layers,
    title: "Multiple Variations",
    description:
      "Receive several angles so you can A/B test and find what resonates best with your audience.",
  },
  {
    icon: Zap,
    title: "30-Second Setup",
    description:
      "Five fields, one click, and your value proposition is on its way. No accounts, no downloads, no complexity.",
  },
  {
    icon: ShieldCheck,
    title: "Proven Frameworks",
    description:
      "Based on high-performing ad copy patterns from thousands of Google Ads campaigns across industries.",
  },
];

const VPGBenefitsSection = () => {
  return (
    <section className="py-24 px-4 bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Badge className="px-3 py-1 text-sm bg-primary/10 text-primary border-primary/20 mb-4">
              What You Get
            </Badge>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              More Than Just a Tagline
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              A complete value proposition package built specifically for Google
              Ads performance.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              className="bg-white rounded-xl border border-border p-6 hover:border-primary/30 hover:shadow-md transition-all"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <benefit.icon className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-bold text-lg mb-2">{benefit.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VPGBenefitsSection;
